
export type EnrollCourse409Result = typeof EnrollCourse409Result[keyof typeof EnrollCourse409Result];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourse409Result = {
  failed: 'failed',
} as const;
